import { render } from "./ComplementInfo.vue?vue&type=template&id=6af81f5c&scoped=true"
import script from "./ComplementInfo.vue?vue&type=script&lang=js"
export * from "./ComplementInfo.vue?vue&type=script&lang=js"

import "./ComplementInfo.vue?vue&type=style&index=0&id=6af81f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af81f5c"]])

export default __exports__